const state = { name: null, status: 'NOT_APPLIED' }

const getters = {
  name(state) {
    return state.name
  },

  status(state) {
    return state.status
  },
}

const mutations = {
  SET(state, name) {
    state.name = name
    state.status = 'APPLIED'
  },
  CLEAR(state) {
    state.name = null
  },
}

const actions = {
  apply({ commit }, name) {
    commit('SET', name)
  },
  initialize({ commit }) {
    commit('CLEAR')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
